import { useFilterInvoiceGridStore } from "presentation/stores/use-filter-invoiceGrid-store";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import InvoiceForm from "../InvoiceForm";

interface ParamProps {
  onClose?: () => void;
  onOpen?: () => void;
  hideAddInvoice: boolean;
}

const HeaderInvoiceGrid: React.FC<ParamProps> = (params: ParamProps) => {
  const { filters, setFilters, resetFilters } = useFilterInvoiceGridStore();

  const [showModal, setShowModal] = useState(false);
  const toast = useRef<Toast>(null);

  const clearFilter = () => {
    resetFilters();
    setFilters({
      query: { value: "", matchMode: "contains" },
      documentTypeName: { value: "", matchMode: "contains" },
      employeeName: { value: "", matchMode: "contains" },
      invoiceYear: { value: "", matchMode: "equals" },
      invoiceMonth: { value: "", matchMode: "equals" },
      invoiceStatus: { value: "", matchMode: "contains" },
    });
  };

  const handleOpenModal = () => {
    setShowModal(true);
    params?.onOpen?.(); // chama o callback se existir
  };

  const handleCloseModal = () => {
    setShowModal(false);
    params?.onClose?.(); // idem para fechar
  };

  return (
    <div className="flex justify-content-between">
      <Dialog
        header="Submeter Fatura"
        visible={showModal}
        style={{ width: "20vw" }}
        onHide={handleCloseModal}
      >
        <InvoiceForm
          isDisable={false}
          onClose={handleCloseModal}
          toastRef={toast}
        />
      </Dialog>

      <div></div>

      <div style={{ display: "flex" }}>
        {!params.hideAddInvoice && (
          <div style={{ display: "flex" }}>
            <Button
              type="button"
              icon="pi pi-plus"
              label="Submeter Fatura"
              outlined
              onClick={handleOpenModal}
              style={{
                backgroundColor: "#2196f3",
                color: "white",
                borderRadius: "8px",
              }}
            />
            <div style={{ width: "10px" }}></div>
          </div>
        )}

        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Limpar"
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "white",
            borderColor: "#2196f3",
            color: "#2196f3",
            borderRadius: "8px",
          }}
        />
        <div style={{ width: "10px" }}></div>
      </div>

      <Toast ref={toast} position="bottom-right" />
    </div>
  );
};
export default HeaderInvoiceGrid;
